// 📄 components/StepHesErpOutput.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { HesErpFormData } from '../../../../../services/commerce/integrationService';

interface StepHesErpOutputProps {
  outputTypeES: string;
  outputProgramES: string;
  outputRoutineES: string;
  onChange: (field: keyof HesErpFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepHesErpOutput({ outputTypeES, outputProgramES, outputRoutineES, onChange, isInvalid }: StepHesErpOutputProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">NACE</span>
          <span>Aplicación ES (Entry Sheet) → Output Determination → Maintain Output Types</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">1. Message Output Control (Aplicación ES)</h3>
        <p className="text-sm text-gray-400">
          Configura el output type que envía la respuesta de la Hoja de Entrada de Servicios creada/modificada desde el ERP hacia SAP Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Output Type <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={outputTypeES}
            onChange={(e) => onChange('outputTypeES', e.target.value.toUpperCase())}
            placeholder="NEU"
            maxLength={4}
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !outputTypeES ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Special Function Program</label>
          <input
            type="text"
            value={outputProgramES}
            onChange={(e) => onChange('outputProgramES', e.target.value.toUpperCase())}
            placeholder="ARBCIG_ENTRYSHEET_U"
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Routine</label>
          <input
            type="text"
            value={outputRoutineES}
            onChange={(e) => onChange('outputRoutineES', e.target.value.toUpperCase())}
            placeholder="SEND_ENTRYSHEET_RES"
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
          />
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">No confundir con el canal HES (Ariba)</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Este output type es exclusivo del flujo iniciado desde el ERP (respuesta de estado) — es independiente del canal HES que recibe la creación desde SAP Ariba.
          </p>
        </div>
      </div>
    </div>
  );
}
